import { render, staticRenderFns } from "./addlm.vue?vue&type=template&id=6a82ec32"
import script from "./addlm.vue?vue&type=script&lang=js"
export * from "./addlm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports